import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "All notifications", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-sm font-bold" }
const _hoisted_4 = { class: "text-sm mt-2" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mt-2 text-xs" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-sm font-bold" }
const _hoisted_10 = { class: "text-sm mt-2" }
const _hoisted_11 = { class: "mt-2 text-xs" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm mt-3"
}
const _hoisted_13 = {
  key: 1,
  class: "navigation_div"
}
const _hoisted_14 = { class: "navigation-num" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Show ")
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"20\">20</option><option value=\"30\">30</option><option value=\"40\">40</option><option value=\"50\">50</option>", 5)
const _hoisted_21 = [
  _hoisted_16
]
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Records ")
const _hoisted_23 = { class: "navigation-menu" }
const _hoisted_24 = {
  key: 1,
  class: "option-disabled"
}
const _hoisted_25 = {
  key: 3,
  class: "option-disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layoutHomeAutoSignQRModal = _resolveComponent("layoutHomeAutoSignQRModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedNotification, (noti, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "p-4 text-black border-t border-gray-500 mt-3",
        key: index
      }, [
        (noti.isQR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(noti.title), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(noti.message), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "btn-primary-small",
                  onClick: ($event: any) => ($setup.displayQRModal(noti.title, noti.message, noti.payload, noti.notificationId))
                }, "Sign this transaction", 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString($setup.Helper.relativeTime(noti.created)), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(noti.title), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(noti.message), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.Helper.relativeTime(noti.created)), 1)
            ]))
      ]))
    }), 128)),
    ($setup.displayedNotification.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No notification at the moment"))
      : _createCommentVNode("", true),
    (($setup.displayedNotification.length >= 10 && $setup.currentPage == 1) || $setup.currentPage > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.pages) = $event)),
              class: "",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.changeRows && $setup.changeRows(...args)))
            }, _hoisted_21, 544), [
              [_vModelSelect, $setup.pages]
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            ($setup.enablePreviousPage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.naviPrevious && $setup.naviPrevious(...args))),
                  class: "option"
                }, "Previous"))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, "Previous")),
            ($setup.enableNextPage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.naviNext && $setup.naviNext(...args))),
                  class: "option"
                }, "Next"))
              : (_openBlock(), _createElementBlock("div", _hoisted_25, "Next"))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_layoutHomeAutoSignQRModal, {
      qr: $setup.qr,
      title: $setup.title,
      message: $setup.message,
      isQRModalShow: $setup.isQRModalOpened,
      onCloseModel: _cache[4] || (_cache[4] = ($event: any) => ($setup.closeModal())),
      onConfirmedButtonPressedAutoSign: _cache[5] || (_cache[5] = ($event: any) => ($setup.closeModal()))
    }, null, 8, ["qr", "title", "message", "isQRModalShow"])
  ]))
}